import { z } from "zod"

export const queryTraitSchema = z.object({
  traitType: z.string(),
  values: z.array(z.string()),
})

export type QueryTrait = z.infer<typeof queryTraitSchema>

/**
 * Given an initial set of traits, returns a new set of traits with a new trait
 * Properly handles removing traitTypes that don't have any values
 */
export function constructTraits(
  initialTraits: QueryTrait[],
  traitType: string,
  value: string,
) {
  const matchedTraitType = initialTraits.find(v => v.traitType === traitType)

  const newTraitValues = matchedTraitType?.values.includes(value)
    ? matchedTraitType.values.filter(v => v !== value)
    : [...(matchedTraitType?.values ?? []), value]

  // Remove the trait type if there are no values
  const newValues = initialTraits
    .filter(v => (v.traitType === traitType ? newTraitValues.length > 0 : true))
    // Otherwise, update the trait type with the new values
    .map(v => {
      if (v.traitType === traitType) {
        return {
          traitType,
          values: newTraitValues,
        }
      }
      return v
    })
    // Lastly, if there was no matched trait, append it to the array
    .concat(matchedTraitType ? [] : [{ traitType, values: newTraitValues }])

  return newValues
}
